import { render, staticRenderFns } from "./tags-input.vue?vue&type=template&id=12d8324a&scoped=true&"
import script from "./tags-input.vue?vue&type=script&lang=js&"
export * from "./tags-input.vue?vue&type=script&lang=js&"
import style0 from "./tags-input.vue?vue&type=style&index=0&id=12d8324a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d8324a",
  null
  
)

export default component.exports